//global variables for the application

export const MOMENT_DATE_FORMAT=`YYYY-MM-DD`
export const STATS_DISTANCE = {
  bike: {
    name: "KM_bike",
    view_name: "Km bici",
    stat:"bike"
  },
  car: {
    name: "KM_car",
    view_name: "Km macchina",
    stat:"car"
  },
  foot: {
    name: "KM_foot",
    view_name: "Km piedi",
    stat:"foot"
  }
}
